import { Calendar } from 'primereact/calendar';
import { useEmployeePerformance } from '../../Hooks/Features/employeeDashboard/useEmployeePerformance';
import {SkeletonContainer} from '../Loader/Loader';

const EmployeePerformance = () => {

    const { date, setDate, months, calendarWrapperRef, loader } = useEmployeePerformance();

    return (
        <div title='Employee Performance' className="w100 employee-dash-height">
            <h5 className='mb-1 widget-title'>Target vs Actual</h5>
            <div style={{ height: "86%" }} ref={calendarWrapperRef}>
                <Calendar className='employee-perf-calendar' view='month' inline value={date} onViewDateChange={(e) => setDate(e.value)} />
                {loader ? <div style={{ height: "85%" }}><SkeletonContainer/></div> :
                    <div className='d-flex flex-wrap w100 justify-content-center align-items-center row-gap-1 column-gap-2' style={{ height: "85%" }}>
                        {months?.map((item) => (
                            <div className='text-center position-relative w30 employee-perf-month-container' title={item?.percent !== null ? item?.percent + "%" : ""} key={item?.month} style={{ backgroundColor: `${item?.percent !== null ? "#dbdbdb" : ""}`, color: item?.percent !== null && item?.percent !== 0 && item?.percent > 50 ? "white" : "" }}>

                                <span>
                                    {item?.month}
                                </span>

                                <div className={`${item?.classname} employee-perf-progress`} style={{ width: `${item?.percent > 100 ? 100 : item?.percent}%`}}></div>

                            </div>
                        ))}
                    </div>
                }
            </div>
        </div>
    )
}

export default EmployeePerformance